import React from 'react';
import { Dialog, DialogContent, Button, Box, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PricingSection from './PricingSection';

interface UpgradePlanModalProps {
  open: boolean;
  onClose: () => void;
  showStripeLinks?: boolean;
  currentPlan?: string;
}

const UpgradePlanModal: React.FC<UpgradePlanModalProps> = ({ open, onClose, showStripeLinks = true, currentPlan }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          width: '1296px',
          height: '858px',
          maxWidth: '100%',
          m: 2,
          overflow: 'hidden',
        },
      }}
    >
      <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: '64px',
            px: 3,
            borderBottom: '1px solid #E9EAEB',
            bgcolor: 'white',
          }}
        >
          <Typography sx={{ fontWeight: 600, fontSize: '18px', color: '#101828' }}>
            Choose your plan
          </Typography>
          <Button
            onClick={onClose}
            startIcon={<ArrowBackIcon />}
            sx={{
              textTransform: 'none',
              color: '#535862',
              fontWeight: 500,
              fontSize: '14px',
              '&:hover': {
                bgcolor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            Return
          </Button>
        </Box>

        <Box sx={{ flex: 1, overflowY: 'auto' }}>
          {/* Reuse the full PricingSection content */}
          <div className="px-8 pt-4 pb-8">
            <PricingSection showStripeLinks={showStripeLinks} currentPlan={currentPlan} />
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default UpgradePlanModal;
